// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import custom from './custom.svg';

type CustomNames =
  | '15'
  | '18'
  | 'check-status'
  | 'checkbox_check'
  | 'checkbox_minimize'
  | 'Coin'
  | 'denied-status'
  | 'question-status'
  | 'social_facebook'
  | 'social_instagram'
  | 'social_linkedin'
  | 'social_tiktok'
  | 'ty'
  | 'Chat'
  | 'label2'
  | 'loading'
  | 'Priplatky'
  | 'rookie'
  | 'Youtube'
;

interface CustomIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: CustomNames;
}

export function CustomIcon({ name, ...props }: CustomIconProps) {
  return <Icon {...props} link={custom} name={name} />
}

